import { type ComponentPropsWithRef, type FC } from 'react';

import { getClassNames } from '@eneco/sparky/util/css';

import { shadowStyle } from './Registration.css';

export const Shadow: FC<ComponentPropsWithRef<'div'>> = ({ className, ...props }) => (
  <div className={getClassNames(shadowStyle, className)} {...props} />
);
